<template>
    <div class="row">
        <coupons-modal v-if="couponSelected" :coupon="couponSelected"></coupons-modal>
        <div class="col-12" v-if="is_valid">
            <vue-title :title="title"></vue-title>
            
            <steps :step="step" :rapd="rapd"></steps>
            
            <div class="mt-3 aside responsive-accordion" id="accordionSummaryr">
                <summary-hotel @onSubmit="onSubmit" :summary="data" :customclass="''" :summaryMobile="true" @discount-changed="handleDiscountChange"
                               :isMobile="isMobile">
                </summary-hotel>
            </div>
            <header-form :rapd="rapd" :collect="isCollectType"></header-form>
            <div class="row justify-content-between">
                <div class="col-lg-7 col-xl-8 pb-5">
                    <div class="accordion d-none mb-3 aside accordion-desktop" id="accordionSummary">
                        <summary-hotel @onSubmit="onSubmit" :summary="data" :customclass="''" :summaryMobile="true">
                        </summary-hotel>
                    </div>

                    <ValidationObserver ref="observer" v-slot="{ invalid }" tag="form" @submit.prevent="onSubmit()"
                                        class="card">
                        <div class="card-body px-0">
                            <div class="col-12 card-header py-sm-0">
                                <h3>{{ __('messages.enter_your_data') }}</h3>
                            </div>
                            <div class="col-12 py-3 pb-0 d-flex">
                                <form-step-one :user="user" :provider="provider"
                                               :submitEvent="submitEvent"></form-step-one>
                            </div>

                            <IconsRAPD v-if="rapd"></IconsRAPD>




                        </div>

                    </ValidationObserver>


                    <div class="card card-blank">
                        <div class="card-body px-0">

                            <div class="col-12 ">

                                <div class="row">
                                    <div class="col-md-12 col-lg-8 d-center">
                                        <p v-if="rapd" class="m-0 summary-details"
                                           v-html="__('messages.this_is_last_step')"></p>
                                    </div>
                                    <div class="col-md-12 col-lg-4 mt-2">
                                        <button id="btn-submit-checkout-hotel" type="button" @click="onSubmit()"
                                                class="btnPrimary w-100">
                                            {{ __('messages.continue') }} <i class="bi bi-chevron-right"></i>
                                        </button>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>



                    <!-- <Comments v-if="data.rate.contractCurrency !== 'USD'" /> -->

                </div>
                <div class="col-lg-5 col-xl-4 aside">
                    <summary-hotel @onSubmit="onSubmit" :summary="data" :customclass="'d-none d-lg-block'"
                                   :summaryMobile="false"></summary-hotel>
                    
                    <MonthsOfferCard v-if="siteConfig.code === 'TB' && isCollectType != 2" />
                    <PaymentOptions v-if="culture.internalCultureCode === 'es-mx' && !rapd && isMsiAvailable && isCollectType != 2" :msiIsAvailible="data.isMsiAvailableMonths" :summary="data" />
                    <GuaranteedPrice v-if="isCollectType != 2" />
                    <cancellation v-if="!rapd" :cancellation="cancellation"></cancellation>
                    <secure-payment></secure-payment>
                    <ResidentsColoModal />
                    <ResidentsPeruModal />

                </div>
            </div>
        </div>
        <finger-print-modal v-if="this.statusType === 'ERROR_TOKEN'"
                            v-bind:quote="data"
                            v-bind:redirectUrl="redirectUrl"
                            v-bind:bookingId="bookingId"
                            :submitBooking="createBooking"
                            :transfer="transfer"
                            v-bind:accept_transfer="user.accept_transfer" />
        <error-checkout v-if="!loading && !is_valid" :quote="responseQuote"></error-checkout>
        <loading v-if="loading"></loading>

    </div>
</template>

<script>
    import { storeToRefs } from 'pinia';
    import Steps from '../components/Steps'
    import HeaderForm from '../components/HeaderForm'
    import SummaryHotel from '../components/SummaryHotel'
    import PaymentOptions from '../components/PaymentOptions'
    import GuaranteedPrice from '../components/GuaranteedPrice'
    import SecurePayment from '../components/SecurePayment'
    import Loading from '../components/Loading'
    import Cancellation from '../components/Cancellation'
    import VueTitle from '../components/VueTitle'
    import FormStepOne from '../form/FormStepOne'
    import CouponsModal from '../components/CouponsModal'
    import CurrencyDisplay from '../../common/CurrencyDisplay'


    import { util } from '../../utils/utils'
    import { HotelAnalytic } from '../../analytics/HotelsAnalytics'
    import { ValidationObserver } from 'vee-validate';
    import { StorageService } from '../../services/StorageService'
    import { AlgoliaServices } from '../../services/AlgoliaService'
    import IconsRAPD from '../components/IconsRAPD';
    import ResidentsColoModal from '../modals/ResidentsColoModal.vue';
    import ResidentsPeruModal from '../modals/ResidentsPeruModal.vue';
    import { CookieService } from '../../services/CookieService';

    import SumaryMinify from '../components/SumaryMinify.vue'
    import SumaryMinifyRender from '../components/SumaryMinifyRender.vue'

    import MonthsOfferCard from '../components/MonthsOfferCard'
    import Breakdown from '../components/Breakdown.vue'
    import { useUserStore } from '../../stores/user';

    import { getBrowserFingerprint } from '../../../utils/fingerprint/fingerprint';
    import { useFingerStore } from '../../stores/fingerprint';
    const { v4: uuidv4 } = require('uuid');

    import { useDiscountStore } from '../../stores/discount';
    import { getHeaders } from '../../../utils/pricetravel/shared/tokenUtil';
    import { useCheckoutStore } from '../../stores/checkout';

    import GlobalUtil from '../../../utils/pricetravel/shared/globalUtil';

    const _paramQuery = window.__pt.fn.search();
    const site = window.__pt.settings.site;
    const culture = window.__pt.cultureData;
    const exchangeRate = window.__pt.exchange;
    const userProfile = window.__pt.user || null;
    const _globalUtil = new GlobalUtil(_paramQuery, site);

    const error_checkout = {
        error_quote: "get-quote",
        error_booking: "create-booking"
    }

    const quoteRequest = window.__pt.data || null;
    let fn = window.__pt.fn;
    export default {
        data() {
            return {
                culture,
                step: 1,
                rapd: false,
                loading: true,
                siteConfig: site,
                isMobile: false,
                data: {},
                cancellation: {},
                params: quoteRequest,
                places: {},
                hash: "",
                source: "",
                user: {
                    name: "",
                    last_name: "",
                    email: "",
                    email_confirmation: "",
                    phone: "",
                    policy_terms: false,
                    dial_code: "",
                    user_key: StorageService.get('userKey'),
                    special_request: ""
                },
                responseQuote: {},
                is_valid: false,
                title: '',
                couponSelected: null,
                provider: 0,
                isMsiAvailable: true,
                isMetaTotal: site.isMetaTotal,
                currencySite: site.currency,
                isCollectType: 0,
                submitEvent: false,
                fingerprintHash: "",
                statusType: "",
                discountObject: {},
                redirectUrl: '',
                bookingId: 0,
                noName: false,

            };
        },
        setup() {
            const checkoutStore = useCheckoutStore();
            const userStore = useUserStore();

            const { getEmail, getPhone, getDialPhone, getUserProfile } = storeToRefs(userStore);
            const { setUser } = userStore;
            const { setQuote } = checkoutStore;

            const storeFingerStore = useFingerStore();
            const { setFingerprintHash, getFingerprintHash } = storeFingerStore;
            const discountStore = useDiscountStore();
            return {
                getEmail,
                setQuote,
                discountStore,
                userStore,
                setFingerprintHash,
                getFingerprintHash,
                getPhone,
                getDialPhone,
                getUserProfile
            }
        },
        async mounted() {
            this.getQuote();
            this.source = CookieService.getCookie("source_origin");
            this.getCookieCoupon();
            this.initialize()
        },
        methods: {
            initialize() {
                let email = this.getEmail;
                const dialCode = this.getDialPhone;
                const phone = this.getPhone;
                const name = this.getUserProfile.name;
                const last_name = this.getUserProfile.lastName;

                if (name && last_name) {
                    this.user.name = name;
                    this.user.last_name = last_name;
                }

                if (dialCode && phone) {
                    this.user.phone = phone;
                    this.user.dial_code = dialCode;
                }
                if (email) {
                    this.user.email = email;
                    this.user.email_confirmation = email;
                }

                if (userProfile != null && (this.user.name == "" || this.user.lastName == "" || this.user.birthdate == "" || this.user.nationality == "" || this.user.phone == "" || this.user.dial_code == "")) {
                    this.noName = true;
                }
            },
            handleDiscountChange(isDiscountApplied) {
                if (isDiscountApplied) {
                    HotelAnalytic.select_discount(this.responseQuote);
                    HotelAnalytic.select_discountBest(this.responseQuote);
                    this.getQuote(true, true);
                } else {
                    this.getQuote(true);
                }
            },
            async getQuote(isDiscount = false, newParamns = false) {
                this.loading = true;
                this.is_valid = false;
                if (isDiscount) {
                    this.params = null;
                }
                let params = this.getParams();

                this.fingerprintHash = await getBrowserFingerprint();

                this.setFingerprintHash(this.fingerprintHash)
                window.fingerprintHash = this.fingerprintHash;

                if (newParamns) {
                    let roomList = [];
                    this.discountStore.discountObject.forEach(rate => {
                        let paramn = {
                            idRate: rate.rate.rateId.toString(),
                            idRoom: rate.room.roomId,
                            mealPlanCode: rate.rate.mealPlanCode,
                            totalAmount: rate.rate.totalAmount.toString(),
                            checkoutHash: rate.rate.checkoutHash,
                            pax: this.formatPax(rate.roomOriginal.pax),
                            rooms: rate.roomOriginal.quantity,
                            provider: 1
                        }
                        roomList.push(paramn);
                    });
                    params.roomList = roomList;
                }

                this.provider = params.provider;

                let response = await axios.post(site.endPoints.quoteCheckoutStepOne, params).catch((data) => this.onError(data, error_checkout.error_quote));
                if (response && response.status == 200) {
                    this.responseQuote = response.data;

                    this.data = this.responseQuote.quote;
                    if (this.data.ratesWithRooms) {
                        this.data.rates = this.data.ratesWithRooms.map(item => item.rate);
                        this.data.rooms = this.data.ratesWithRooms.map(item => item.room);
                        this.data.rate = this.data.rates[0];
                        this.data.room = this.data.rooms[0];
                        this.isCollectType = this.data.rate.collectType;
                        this.cancellation = this.data.rates;
                        this.provider = params.roomList.every(rm => rm.provider === 1) ? 1 : params.roomList[0].provider;
                    }
                    if (!newParamns) {
                        StorageService.set('pt.margin_chk', this.data.totalRate.margin);
                    }

                    this.hash = this.responseQuote.hash;
                    this.places = this.responseQuote.places;
                    this.isMsiAvailable = !(this.data.isMsiAvailable && this.data.isMsiAvailableMonths.length > 0);
                    this.title = `${this.data.name} - ${this.__("messages.checkout_title")}`;
                    this.is_valid = true;
                    this.rapd = this.data.rate.bookNowPayLater.isBookNowPayLater;
                    this.isCollectType = this.data.rate.collectType;

                    AlgoliaServices.getEventAlgolia("Add to Cart", "addToCart");

                    HotelAnalytic.setHotelPaymentFunnel(this.responseQuote);
                    HotelAnalytic.setHotelReservationDetail(this.responseQuote);

                    const currentDate = new Date();
                    this.setQuote(this.responseQuote);
                    const checkInDate = new Date(params.checkIn);
                    const isDifferentThan2_0 = params.paxes.some(pax => !(pax.adults === 2 && pax.children.length === 0));
                    const daysInAdvance = (checkInDate - currentDate) / (1000 * 60 * 60 * 24);
                    const isMoreThan90Days = daysInAdvance > 90;
                    if (newParamns) {
                        HotelAnalytic.select_discount(this.responseQuote);
                    }
                    let notdiscount = site.hotelDiscountBlackList ? site.hotelDiscountBlackList.includes(this.responseQuote.quote.hotelId) : false;
                    if (!isDiscount && !this.userStore.user.id && !isDifferentThan2_0 && !isMoreThan90Days && !notdiscount) {
                        this.getQuoteDiscount();
                    }
                    if (this.couponSelected !== null) {
                        $('.banner_coupon').css('display', 'flex');
                    }
                }

                this.loading = false;

            },
            formatPax(pax) {
                const adults = pax.adults;
                const children = pax.children.length > 0 ? pax.children.join(",") : null;

                if (children) {
                    return `${adults}|${children}`;
                } else {
                    return `${adults}`;
                }
            },
            async onSubmit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    HotelAnalytic.addShippingInfoTb(this.responseQuote);
                    this.createBooking();
                    
                }
                else
                    this.submitEvent = !this.submitEvent;

            },
            async getQuoteDiscount() {
                if (!site.configTokens || site.configTokens.length === 0) {
                    console.error("No hay tokens disponibles en site.configTokens");
                    return;
                }

                let params = this.getParams();
                let paxes = this.getPaxesRates(params.paxes);
                let userKey = StorageService.get('pt.userKey');

                for (const tokenData of site.configTokens) {
                    let paramsQuote = {
                        channelId: params.chkSource,
                        responseTimeout: 20000,
                        checkin: params.checkIn.slice(0, 10),
                        checkout: params.checkOut.slice(0, 10),
                        hotelid: params.idHotel,
                        login: false,
                        mobile: params.isMobile,
                        site: site.domain,
                        ispackage: false,
                        source: params.source,
                        userKey: userKey,
                        CampaignToken: tokenData.token
                    };

                    paxes.paxesFormat.forEach((room) => {
                        paramsQuote['rooms'] = room;
                    });

                    try {
                        let response = await axios.get(!params.applicable ? site.endPoints.detailQuoteUrlFam : site.endPoints.detailQuoteUrl, {
                            params: paramsQuote,
                            headers: getHeaders()
                        });
                        let compareRates = this.compareRates(params, response.data);
                        if (compareRates) {
                            break;
                        }
                    } catch (error) {
                        this.onErrorQuote(error, "Error al obtener la cotización con CampaignToken " + tokenData.Token);
                    }
                }
            },
            onErrorQuote(error, message) {
                console.error(message, error);
            },
            compareRates(params, response) {
                let matchFound = false;
                let rateFounds = [];
                response.rooms.forEach((room) => {
                    for (let i = 0; i < room.rate.length; i++) {
                        let rate = room.rate[i];
                        this.data.ratesWithRooms.forEach((roomCot) => {
                            if (roomCot.rate.paxFam == rate.paxFam && roomCot.room.roomID.toString() == room.roomId && roomCot.rate.mealPlan == rate.mealPlanCode) {
                                rateFounds.push({ rate: rate, room: room, roomOriginal: roomCot.room });
                            }
                        })
                    }
                });
                if (rateFounds && rateFounds.length > 0) {
                    let sumTotal = 0;
                    rateFounds.forEach(rate => {
                        sumTotal += rate.rate.totalAmount * rate.roomOriginal.quantity;
                    });
                    let saved = (this.data.totalRate.totalAmount - sumTotal) * 1;
                    let discountPercentage = ((saved * 100) / this.data.totalRate.totalAmount);
                    let isValid = discountPercentage > 2 && saved >= fn.thresHold(site.code);;

                    if (isValid) {
                        matchFound = true;
                        let discountObject = rateFounds;
                        this.discountStore.setDiscount(false, saved, discountObject);
                        this.responseQuote.discount = saved;
                        let margin = 0;
                        margin = discountObject.reduce((acc, rate) => acc + (rate.margin || 0), 0);
                        this.responseQuote.quote.margin = margin.toFixed(2) * 100;
                        HotelAnalytic.discountEvent(this.responseQuote);
                    }
                }
                if (!matchFound) {
                }
                return matchFound;
            },
            setCultureURL(url) {
                const urlObj = new URL(url);
                urlObj.searchParams.set("culture", culture.internalCultureCode);
                return urlObj.toString();
            },
            getPaxesRates(box) {
                let boxLength = box && box.length;
                let paxes = {
                    adults: 0,
                    children: 0,
                    paxesFormat: []
                };
                for (let i = 0; box && i < boxLength; i++) {
                    const pax = box[i];
                    let paxFormat = "";
                    paxes.adults += pax.adults;
                    paxFormat += `${pax.adults}`;

                    if (pax.children && pax.children.length) {
                        paxes.children += pax.children.length;
                        paxFormat += `|${pax.children.map(it => it.year).join(',')}`;
                    }

                    paxes.paxesFormat.push(paxFormat);
                }
                return paxes;
            },
            async createBooking() {
                const html = this.data.rate.breakdownExcluded.length > 0 && this.isCollectType != 2 ? await this.generateHTML() : "";
                //const htmlCancellation = await this.generateHTMLCancellation();
                const htmlHC = this.isCollectType == 2 ? await this.generateHTMLHotelCollect() : "";
                let paramsAplicabble = this.getParams();
                this.loading = true;
                let params = {
                    hash: this.hash,
                    customer: this.user,
                    site: culture.site,
                    cultureCode: culture.cultureCode,
                    places: this.places,
                    isMobile: this.isMobile,
                    roomExtra: {
                        roomID: this.data.room.roomID + "",
                        roomPrice: this.data.rate.averageRateWithTaxes + "",
                        roomCoupon: this.data.rate.discount + ""
                    },
                    IsMsiAvailable: this.data.isMsiAvailable,
                    isMsiAvailableMonths: this.data.isMsiAvailableMonths,
                    quoteSpecialInfoText: html,
                    //cancellationPolicies: htmlCancellation,
                    breakdownHtml: htmlHC,
                    collectType: this.isCollectType,
                    applicable: paramsAplicabble.applicable,
                    fingerprintHash: this.fingerprintHash,
                    exchangeInfoContainer: {
                        isActive: exchangeRate.base != exchangeRate.currency && this.isCollectType != 2,
                        referenceAmount: this.data.totalRate.totalAmount * exchangeRate.rate,
                        referenceCurrency: exchangeRate.currency,
                        referenceDescription: exchangeRate.currency,
                        originalCurrency: exchangeRate.base,
                        originalDescription: exchangeRate.base,
                    },
                    siteInformation: util.getSiteInformation()
                };
                params.customer.phone = params.customer.phone + '';
                HotelAnalytic.checkoutPaxes(this.user);
                
                let response = await axios.post(site.endPoints.bookingCheckout, params).catch((data) => this.onError(data, error_checkout.error_booking));
                this.loading = false;

                if (response && response.status == 200) {
                    this.onRedirect(response)
                } else {
                    this.onError();
                }

            },
            async getCookieCoupon() {

                let coupon = CookieService.getCookie("codept");

                if (!coupon) {
                    return;
                }

                let responseCoupon = await axios.get(`${site.endPoints.couponUrl}?DiscountCode=${coupon}`).catch((data) => console.log("empty coupon"));

                if (responseCoupon && responseCoupon.data && responseCoupon.data.id && responseCoupon.data.enable) {
                    this.couponSelected = responseCoupon.data;
                    $('.banner_coupon').css('display', 'flex');
                    $('.close_coupon').on('click', () => {
                        $('.banner_coupon').css('display', 'none');
                    });

                    $('.coupon_name').text(`${this.couponSelected.description.length > 130 ? this.couponSelected.description.substring(0, 130) + '...' : this.couponSelected.description}`);
                    $('.coupon_desc').text(this.couponSelected.code);
                }



            },
            onError(data, step_error) {
                this.loading = false;
                this.is_valid = false;
                let params = this.getParams();
                let response = data && data.response && data.response.data ? data.response.data : null;
                if (response) {
                    this.responseQuote = data.response.data;
                    if (this.responseQuote && this.responseQuote.urlRedirect) {
                        this.is_valid = true;
                        this.onRedirect(data.response);
                    }
                }

                if (step_error) {
                    HotelAnalytic.onError(response, params, step_error);
                }
            },
            async generateHTML() {
                const propsData = {
                    summary: this.data,
                    source: this.source,
                    isMetaTotal: this.isMetaTotal,
                    currencySite: this.currencySite
                };
                const vm = new Vue({
                    render: h => h(Breakdown, { props: propsData })
                });
                vm.$mount();
                var finalHTML = "";
                const cssFileUrl = `/assets/css/dist/${site.siteName}/global.css`;
                await fetch(cssFileUrl)
                    .then(response => response.text())
                    .then(cssContent => {

                        finalHTML = `
                <html>
                    <head>
                        <style>
                        ${cssContent}
                        </style>
                    </head>
                    <body>
                        ${vm.$el.outerHTML}
                    </body>
                </html>`;

                    });
                return finalHTML;
            },
            async generateHTMLCancellation() {
                const propsData = {
                    cancellation: this.cancellation
                };
                const vm = new Vue({
                    render: h => h(Cancellation, { props: propsData })
                });
                vm.$mount();
                var finalHTML = "";
                const cssFileUrl = `/assets/css/dist/${site.siteName}/global.css`;
                await fetch(cssFileUrl)
                    .then(response => response.text())
                    .then(cssContent => {

                        let customHtml = vm.$el.outerHTML;
                        finalHTML = util.htmlCancellation(cssContent, customHtml);
                    });
                return this.cancellation.some(item => item.cancellation.isCancellationFree) ? finalHTML : "";
            },
            async generateHTMLHotelCollect() {

                var finalHTML = "";
                const cssFileUrl = `/assets/css/dist/${site.siteName}/global.css`;

                const propsData = {
                    summary: this.data,
                    isBooking: true
                };
                const vm = new Vue({
                    render: h => h(SumaryMinifyRender, { props: propsData })
                });
                vm.$mount();
                await fetch(cssFileUrl)
                    .then(response => response.text())
                    .then(cssContent => {

                        finalHTML = util.htmlHotelCollect(cssContent, vm.$el.outerHTML);
                    });

                return finalHTML;
            },
            onRedirect(response) {
                this.loading = true;
                let data = response.data;
                let status = data.status;
                let urlRedirect = this.setCultureURL(data.urlRedirect);
                this.redirectUrl = data.urlRedirect;
                let timeout = site.rapdTimeOut * 1000;
                let time = data.isRAPD ? timeout : 0;
                this.statusType = status;
                this.bookingId = 0;


                if (status === "ERROR_TOKEN") {
                    setTimeout(() => {
                        this.loading = false;
                        //hideModal('modal-loader-checkout');
                        $("#modal-fingerPrint").modal("show");
                    }, 1100);
                } else if (urlRedirect) {
                    setTimeout(() => {
                        location.href = urlRedirect;
                    }, time);
                } else {
                    this.onError(response, "url_redirect")
                }


            },
            getParams() {
                let params = null;
                let session = StorageService.getSession("checkoutData")
                let paramsCheckout = this.params;
                if (paramsCheckout) {
                    StorageService.setSession("checkoutData", paramsCheckout);
                    let result = util.GetPaxesKeys(paramsCheckout.paxes, true);
                    params = {
                        Site: paramsCheckout.site,
                        IdRate: paramsCheckout.idRate,
                        IdRoom: paramsCheckout.idRoom,
                        IdHotel: paramsCheckout.idHotel,
                        MealPlanCode: paramsCheckout.mealPlanCode,
                        CheckIn: paramsCheckout.checkIn,
                        CheckOut: paramsCheckout.checkOut,
                        ChkSource: paramsCheckout.chkSource,
                        IsBookNowPayLater: paramsCheckout.isBookNowPayLater,
                        TotalAmount: paramsCheckout.totalAmount,
                        Source: paramsCheckout.source,
                        HotelCheckIn: paramsCheckout.hotelCheckIn,
                        CheckoutHash: paramsCheckout.checkoutHash,
                        Rooms: paramsCheckout.rooms,
                        CampaignToken: paramsCheckout.campaignToken,
                        IsMobile: paramsCheckout.isMobile
                    }
                    this.isMobile = paramsCheckout.isMobile;
                    params = { ...params, ...result }
                }
                if (session && !params) {
                    this.isMobile = session.isMobile;
                    paramsCheckout = session;
                }

                util.saveCookieQuote(paramsCheckout);
                return paramsCheckout || {};
            },


        },
        components: {
            Steps,
            HeaderForm,
            FormStepOne,
            SummaryHotel,
            PaymentOptions,
            GuaranteedPrice,
            MonthsOfferCard,
            SecurePayment,
            Loading,
            Cancellation,
            VueTitle,
            ValidationObserver,
            IconsRAPD,
            ResidentsColoModal,
            ResidentsPeruModal,
            CouponsModal,
            Breakdown,
            SumaryMinify,
            CurrencyDisplay
        }
    }
</script>
